import { siteConfig } from "@/config/site";

export type PricingTier = {
  name: string;
  price: string;
  priceNote: string;
  description: string;
  features: string[];
  cta: string;
  highlight?: boolean;
};

export const PRICING_TIERS: PricingTier[] = [
  {
    name: "Focused",
    price: "$6,000",
    priceNote: "per month",
    description: "Ideal for established local businesses in competitive metros ready for a real organic channel.",
    features: [
      "Technical foundation cleanup",
      "Full Local Pack dominance programme",
      "Google Business Profile overhaul",
      "Monthly high-intent content production",
      "Quarterly authority building",
      "Weekly transparency reporting",
    ],
    cta: "Book a Strategy Call",
  },
  {
    name: "Growth",
    price: "$12,500",
    priceNote: "per month",
    description: "For multi-location operators or B2B teams competing for national organic pipelines.",
    features: [
      "Everything in Focused",
      "Multi-location GBP management",
      "Advanced AEO/GEO optimization",
      "Bi-weekly content sprints",
      "Aggressive digital PR & links",
      "Custom Looker Studio dashboard",
    ],
    cta: "Book a Strategy Call",
    highlight: true,
  },
  {
    name: "Enterprise",
    price: "$25,000+",
    priceNote: "per month",
    description: "Custom programs for category-leading brands with high content volume and global authority needs.",
    features: [
      "Everything in Growth",
      "Programmatic SEO architecture",
      "Entity graph blueprinting",
      "Executive strategy sessions",
      "Priority response SLA",
      "Custom engineering support",
    ],
    cta: "Contact for Scoping",
  },
];

export const LOCAL_PRICING = {
  singleCity: {
    range: "$2,000 – $3,200",
    note: "per month, per location",
    context: "For smaller TX markets like Cedar Park or Georgetown.",
  },
  corridor: {
    range: "$3,500 – $6,000",
    note: "per month",
    context: "Full corridor coverage (e.g., Round Rock–Pflugerville–Hutto).",
  },
};
